import { DOCUMENT, inject, Injectable } from '@angular/core';

import { env } from '@amfam/environment';

import { UtilService } from '../core/util.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private document = inject<Document>(DOCUMENT);
  private utilService = inject(UtilService);

  loadFeedbackSDK() {
    this.loadQualtricsSDK();
  }

  private loadQualtricsSDK() {
    this.utilService.log('[FeedbackService] loadQualtricsSDK called');
    this.utilService.log(`[FeedbackService] Environment:  ${env.environment}`);
    this.utilService.log(`[FeedbackService] Document body exists: ${!!this.document.body}`);

    // Check if script already exists
    const divId = env.environment === 'prod' ? 'ZN_3KpFpzejn6fYsfG' : 'ZN_3nod2PBUcSujweT';
    if (this.document.getElementById(divId)) {
      this.utilService.warn('[FeedbackService] Qualtrics already loaded (div exists)');
      return;
    }

    if (!this.document.body) {
      this.utilService.error(
        '[FeedbackService] Cannot insert Qualtrics - document.body does not exist yet'
      );
      return;
    }

    // Get the script content and create elements that will execute
    const config =
      env.environment === 'prod'
        ? {
            url: 'https://zn3kpfpzejn6fysfg-amfamcx.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_3KpFpzejn6fYsfG',
            divId
          }
        : {
            url: 'https://zn3nod2pbucsujwet-amfamcx.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_3nod2PBUcSujweT',
            divId
          };

    // Create script element (this will execute when appended)
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.textContent = this.getQualtricsScript(config.url);

    // Create the required div element
    const div = this.document.createElement('div');
    div.id = config.divId;

    // Append both elements to the body
    this.utilService.log('[FeedbackService] Inserting Qualtrics script and div into document body');
    this.document.body.appendChild(script);
    this.document.body.appendChild(div);
    this.utilService.log('[FeedbackService] Qualtrics script executed and div inserted');
  }

  private getQualtricsScript(url: string): string {
    return `
(function(){var g=function(g){
this.go=function(){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)};
this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
try{(new g("${url}")).start()}catch(i){}})();
    `;
  }
}
